import * as PIXI from 'pixi.js'
import GlobalDispatcher from "../../events/GlobalDispatcher";
import FlashLib from "flashlib";
import EntryPoint from "Engine/EntryPoint";

export default class BasePreloaderView extends PIXI.Container {

    constructor(gameSizeConfig) {
        super();
        this.gameSizeConfig = EntryPoint.ScaleManager.currentSizes; //gameSizeConfig;
        this.init();
        this.addListeners();
        this.buildPrePreLoader();
    }

    init() {

    }

    addListeners() {
        GlobalDispatcher.add('preloaderController:progress', this.onProgress, this);
        GlobalDispatcher.addOnce('preloaderController:loadingPreloaderComplete', this.buildPreLoader, this);
        GlobalDispatcher.addOnce('preloaderController:allResourcesLoaded', this.onAllResourcesLoaded, this);
    }

    buildPrePreLoader() {
        let circle = null;
        let circles = [];
        let circlesContainer = new PIXI.Container();
        for (let i = 0; i < 7; i++) {
            circle = new PIXI.Graphics();
            circle.beginFill(0xff0000, 1);
            circle.drawCircle(0, 0, 20);
            circle.endFill();

            circle.x = i * 50;
            circle.y = 0;
            circle.alpha = (7 - i) / 7;
            circlesContainer.addChild(circle);
            circles.push(circle)
        }
        circlesContainer.x = (this.gameSizeConfig.width - circlesContainer.width) / 2;
        circlesContainer.y = (this.gameSizeConfig.height - circlesContainer.height) / 2;
        this.addChild(circlesContainer);

        /*let currentItem = 7;
        setInterval(() => {
            circles.forEach((item, index) => {
                item.alpha = (currentItem - index) / 7;
            });
            currentItem--;
            if (currentItem < 0) {
                currentItem = 7;
            }
        }, 500);*/

        /*let bgGraphics = new PIXI.Graphics();
        bgGraphics.beginFill(0x0, 1);
        bgGraphics.drawRect(0, 0, 960, 536);
        bgGraphics.endFill();
        this.addChild(bgGraphics);

        this.percentText = new PIXI.Text('0%', {fill: 0xffffff});
        this.percentText.anchor.set(0.5, 0.5);
        this.percentText.x = bgGraphics.width / 2;
        this.percentText.y = bgGraphics.height / 2 + 20;
        this.addChild(this.percentText);

        this.loadingText = new PIXI.Text('Loading', {fill: 0xffffff});
        this.loadingText.anchor.set(0.5, 0.5);
        this.loadingText.x = bgGraphics.width / 2;
        this.loadingText.y = bgGraphics.height / 2 - 20;
        this.addChild(this.loadingText);*/
    }

    buildPreLoader() {
        this.removeChildren();
        this.preloader = FlashLib.createItemFromLibrary('Main', 'PreloaderFlashLib');
        this.percentText = this.preloader.getChildByName('progressValue');
        this.addChild(this.preloader);
    }

    onAllResourcesLoaded() {

    }

    onProgress(data) {
        let aaa = 100 / 9; //количество элементов прогрессбара
        let sss = data.params / aaa; //сколько элементов заполняют текущий прогресс (дробное)
        let ddd = Math.floor(sss); //сколько элементов заполняет текущий прогресс (целое)
        //let xxx = sss - ddd //какя дробная чать заполняет прогресс

        this.percentText.text = Math.ceil(data.params).toString() + '%';
    }
}
